module.exports = __webpack_public_path__ + "img/Stemness-NPC_GSE200310.d7d1e288.png";